import { render, staticRenderFns } from "./UserChallengesList.vue?vue&type=template&id=85ae78e4&scoped=true&"
import script from "./UserChallengesList.vue?vue&type=script&lang=ts&"
export * from "./UserChallengesList.vue?vue&type=script&lang=ts&"
import style0 from "./UserChallengesList.vue?vue&type=style&index=0&id=85ae78e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ae78e4",
  null
  
)

export default component.exports